import React from "react";
import { Button, Modal } from "react-bootstrap";

const MaxAmountPopup = (props) => {
  return (
    <Modal
      class="text-right modal-dialog"
      show={props.show}
      backdrop="static"
      keyboard={false}
      onHide={props.onHide}
      aria-labelledby="contained-modal-title-success"
      centered
      data-test="test-right"
    >
      <Modal.Header
        closeButton
        className="modal-upload-button-border success-close"
      >
        <Modal.Title className="modal-title">Maximum Amount Selected</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body invoice-success">
        <p>You have selected invoice that equal to total is over 100K in total, please change the selection</p>
      </Modal.Body>
      <Modal.Footer>     
        <Button
          className="btn btn-blue"
          data-test="modal-cancel"
          onClick={props.onHide}>
          Close         
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MaxAmountPopup;
